import { render, staticRenderFns } from "./MaterialItemForm.vue?vue&type=template&id=400aa2df&"
import script from "./MaterialItemForm.vue?vue&type=script&lang=ts&"
export * from "./MaterialItemForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports